import {
  Box,
  SkeletonAvatar,
  SkeletonTag,
  SkeletonText,
} from '@dev-spendesk/grapes';

import { SidePanelLoader } from 'src/core/common/components/SidePanel';
import { useTranslation } from 'src/core/common/hooks/useTranslation';

export const PanelPaymentLoader = () => {
  const { t } = useTranslation('global');
  return (
    <SidePanelLoader
      title={t('payments.panel.paymentDetails')}
      header={
        <div className="-mb-24 flex flex-col gap-8">
          <Box
            variant="secondary"
            className="flex min-h-[80px] items-center py-16"
          >
            <div className="flex w-full items-center gap-8">
              <SkeletonAvatar size="m" className="shrink-0" />
              <SkeletonText size="xxl" width="200px" className="block" />
              <SkeletonTag width="100px" className="ml-auto block" />
            </div>
          </Box>
          <Box
            variant="secondary"
            className="flex min-h-[80px] items-center py-16"
          >
            <div className="flex w-full items-center gap-8">
              <SkeletonAvatar size="m" className="shrink-0" variant="square" />
              <SkeletonText size="xxl" width="160px" className="block" />
              <div className="ml-auto flex flex-col items-end gap-4">
                <SkeletonText width="100px" size="xl" className="h-24" />
                <SkeletonText width="50px" size="xl" />
              </div>
            </div>
          </Box>
          <SkeletonTag width="50%" className="mt-24" />
        </div>
      }
    >
      <div>
        <SkeletonText size="xl" width="33%" className="block h-24" />
        <SkeletonText size="xl" width="50%" className="my-16 block h-24" />
      </div>
    </SidePanelLoader>
  );
};
